export function normalizeString(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

export function calculateAge(dobString) {
  if (!dobString) return 0;
  const today = new Date();
  const birthDate = new Date(dobString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function comparePlayers(guess, answer) {
  const hints = {};
  hints.club = guess.club === answer.club ? "correct" : "incorrect";
  hints.league = guess.league === answer.league ? "correct" : "incorrect";
  hints.country = guess.country === answer.country ? "correct" : "incorrect";
  hints.position = guess.position === answer.position ? "correct" : "incorrect";

  if (guess.number === answer.number) {
    hints.number = "correct";
  } else {
    const isClose = Math.abs(guess.number - answer.number) <= 5;
    hints.number = isClose ? "partial" : "incorrect";
  }

  const guessAge = calculateAge(guess.dateofbirth);
  const answerAge = calculateAge(answer.dateofbirth);

  if (guessAge === answerAge) {
    hints.age = "correct";
  } else {
    const isClose = Math.abs(guessAge - answerAge) <= 2;
    hints.age = isClose ? "partial" : "incorrect";
  }

  return hints;
}

export function findPlayerKey(playersData, displayName) {
  const normalized = normalizeString(displayName);
  for (const [key, player] of Object.entries(playersData)) {
    if (normalizeString(player.displayName) === normalized) return key;
  }
  return null;
}

export function getTodayKey() {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "America/New_York",
  });
}

export function getTodayKeyForCache() {
  return getTodayKey().replace(/-/g, "");
}
